import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class CashNoteDetailService extends DatabaseGwService{
  URL_PATH:string = '/cash-note-details';
}
